export default "__VITE_ASSET__5d631737__"